export const trimStart = (input: string, toTrim: string): string => {
    if (!input || !toTrim) return input;

    if (!input.startsWith(toTrim)) return input; // stop recursion

    const trimmed = trimStart(input.slice(toTrim.length), toTrim);
    return trimmed;
};
